<!--左边菜单-->
<template>
  <div :class="['leftMenuBody',{'active':isCollapse}]">
    <!-- <div class="shrinkDiv">
			<img src="../../../../public/static/image/科技蓝/leftMenu/shrink1.png" class='shrinkButton' @click="isCollapse=!isCollapse" />
			
		</div> -->
    <el-scrollbar style="height:97%;width: 100%;margin-top: 40px;">
      <el-menu :style="getMenuStyle" :default-active="defaultActive" @select="handleSelect" unique-opened
        :collapse="isCollapse" collapse-transition class="el-menu-vertical-demo" text-color="#fff"
        active-text-color="#ffd04b">
        <template v-for="(item) in dataList">
          <el-submenu :index="item.id" v-if='item.hasSonMenu==1'>
            <template slot="title">
              <img :src="getClassName(item.iconFile)" class="menuImage" />
              <span>{{item.rightname}}</span>
            </template>
            <el-menu-item-group>
              <!--判断是否有二级菜单-->
              <template v-for="(item2) in item.next">
                <el-submenu :index="item2.id" v-if='item2.hasSonMenu==1'>
                  <template slot="title">
                    <span><i class="item_i">●</i>{{item2.rightname}}</span>
                  </template>
                  <el-menu-item-group>
                    <el-menu-item :index="item3.id" v-for='(item3) in item2.next'
                      class="item_3">{{item3.rightname}}</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
                <el-menu-item :index="item2.id" v-else><i class="item_i">●</i>{{item2.rightname}}</el-menu-item>
              </template>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item :index="item.id" v-else>
            <img :src="getClassName(item.iconFile)" class="menuImage" />
            <span slot="title">{{item.rightname}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
  // import {getNowLogo} from "../../../api/abbNewApi"
  export default {
    components: {},
    props: {
      //数据源，可查看设备树或者啥的
      dataList: {
        type: Array,
        required: true,
      },
      nowMenu: {
        type: Array,
        required: true,
      }
    },
    data () {
      return {
        isCollapse: false,
        defaultActive: "",
        selectMenu: {},
        newLogo: [],
      }
    },
    created () {},
    mounted () {
      this.initialData()
      // this.getNowLogo_fn()
    },
    destroyed () {},
    computed: {
      // nowWeLogo(){
      // 	return this.$store.cacheStore.state.nowWeLogo
      // },
      getClassName () {
        return imgName => {
          return this.$store.resourcesStore.getters.getResourcesByName('menu/'+imgName+'.png')
        }
      },
      getMenuStyle () {
        // console.log(this.isCollapse);
        //  this.$store.cacheStore.commit("setIsCollapse", this.isCollapse)
        if(this.isCollapse) {
          return {
            // 'width': '0.8rem',
          }
        } else {
          return {
            // 'width': '2rem',
            'padding-bottom': '70px',
          }
        }
      },
      setIsCollapse () {//当前建筑
        return this.$store.cacheStore.state.setIsCollapse;
      }

    },
    watch: {
      nowMenu (val) {
        if(val.length!=0) {
          this.defaultActive=val[0].id
        }
      },
      setIsCollapse (val) {
        this.isCollapse=val
      },
      //   nowWeLogo() {
      //           this.getNowLogo_fn()
      // 	}

    },
    methods: {
      //获取当前logo
      // getNowLogo_fn(){
      //    getNowLogo().then(res => {
      // 	if(res.code == 200){
      // 		console.log(res);
      // 		this.newLogo  = [res.data]
      // 	}else {
      // 		this.newLogo =  []
      // 	}
      //    })
      // },
      initialData () {

        if(isempty(this.dataList[0].next)) {
          this.defaultActive=this.dataList[0].id
          this.selectMenu=this.dataList[0]
        } else {
          this.selectMenu=this.dataList[0].next[0]
          this.defaultActive=this.dataList[0].next[0].id
        }
        this.$emit('checkItem',this.selectMenu)

        //默认选中第一个
      },
      handleSelect (key,keyPath) {
        this.recursion(this.dataList,key)
        this.$emit('checkItem',this.selectMenu)
      },
      recursion (list,key) {
        list.forEach(item => {
          if(item.id==key) {
            this.selectMenu=item
          } else {
            if(!isempty(item.next)) {
              this.recursion(item.next,key)
            }
          }
        })
      }
    }
  }
</script>
<style>
  /*.el-menu {*/
  /*	background: #095f4e !important;*/
  /*}*/
  /*.leftMenuBody .el-menu-item:hover {*/
  /*	background: #02e59e2e !important;*/
  /*}*/
  /*.el-submenu__title:hover{*/
  /*	background: #02e59e2e !important;*/
  /*}*/
  /*.leftMenuBody {*/
  /*	background: #095f4e !important;*/
  /*}*/
</style>
<style scoped lang='scss'>
  .item_3 {
    transform: translateX(-10px);
  }

  .item_i {
    position: relative;
    display: inline-block;
    bottom: 3px;
    right: 6px;
    width: 8px;
  }

  // .shrinkDiv {
  // 	color: #fff
  // }
  /deep/ i {
    color: #fff !important;
  }
  /deep/.el-submenu .el-menu-item {
    margin-bottom: 0px;
  }

  .el-menu--collapse {
    width: 0.8rem;
  }

  .el-menu--collapse .menuImage {
    margin-left: 4px;
  }

  .leftMenuBody {
    // max-width: 200px;
    width: 2rem;
    height: 100%;
    transition: 0.35s;
    flex-shrink: 0;

    &.active {
      width: 0.8rem;
    }
  }

  .menuImage {
    /* width: .18rem; */
    padding-right: 4px;
    width: 24px;
    height: 24px;
  }

  .shrinkButton {
    cursor: pointer;
  }

  .shrinkDiv {
    display: flex;
    align-items: center;
    justify-content: center;
    height: .3rem;
    /*background:#095f4e;*/
  }

  /*.el-menu {*/
  /*	background: #095f4e !important;*/
  /*}*/
  /*.el-menu-item:hover {*/
  /*	background: #02e59e2e;*/
  /*}*/
  /*.el-menu-item.is-active {*/
  /*	background: #02e59e2e;*/
  /*}*/
  /*.el-submenu:hover {*/
  /*	background: #02e59e2e;*/
  /*}*/
  /*.is-opened {*/
  /*	background: #02e59e2e;*/
  /*}*/
</style>
<style>
  .leftMenuBody .el-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
    /*overflow-y: hidden;*/
  }
</style>